import React, { Component } from 'react';
import { Grid, TextField, Button, CircularProgress } from '@material-ui/core';
import { LocationAddress } from '../../api/models/LocationAddress';
import PostalCodeInput from '../../Common/PostalCodeInput';
import { postalCodeLookup } from '../../Auth/components/SignUp/PostalCodeLookup';

type Props = {
    locationData: LocationAddress,
    updateLocationDataBusy: boolean,
    updateAccountInfoSuccess: boolean | null,
    updateLocationData: (locationData: LocationAddress) => void
}

type State = {
    locationData: LocationAddress
    postalCodeFormatError: boolean,
    isDirty: boolean
}

class LocationDetails extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            locationData:
            {
                postalCode: this.props.locationData.postalCode,
                stateCode: this.props.locationData.stateCode,
                street: this.props.locationData.street,
                streetNumber: this.props.locationData.streetNumber,
                suburb: this.props.locationData.suburb
            },
            postalCodeFormatError: false,
            isDirty: false
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.updateAccountInfoSuccess === null && this.props.updateAccountInfoSuccess === true)
            this.isDirty()
    }


    isDirty = () => {
        let isDirty = (this.state.locationData.postalCode !== this.props.locationData.postalCode ||
            this.state.locationData.stateCode !== this.props.locationData.stateCode ||
            this.state.locationData.street !== this.props.locationData.street ||
            this.state.locationData.streetNumber !== this.props.locationData.streetNumber ||
            this.state.locationData.suburb !== this.props.locationData.suburb)

        this.setState({ isDirty })
    }

    render() {
        return (
            <Grid style={{ width: '100%', padding: "15px" }} container alignContent={"center"} alignItems={"center"} spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        onChange={(e) => this.setState({ locationData: { ...this.state.locationData, streetNumber: e.target.value } }, () => this.isDirty())}
                        value={this.state.locationData.streetNumber}
                        label="Street Number"
                        margin="normal"
                        variant="standard"
                        style={{ width: '100%' }}
                    ></TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        onChange={(e) => this.setState({ locationData: { ...this.state.locationData, street: e.target.value } }, () => this.isDirty())}
                        value={this.state.locationData.street}
                        label="Street"
                        margin="normal"
                        variant="standard"
                        style={{ width: '100%' }}
                    ></TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        onChange={(e) => this.setState({ locationData: { ...this.state.locationData, suburb: e.target.value } }, () => this.isDirty())}
                        value={this.state.locationData.suburb}
                        label="Suburb"
                        margin="normal"
                        variant="standard"
                        style={{ width: '100%' }}
                    ></TextField>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <PostalCodeInput
                        value={this.state.locationData.postalCode}
                        onChange={(value: string, isValid: boolean) => {
                            let newLocationData = { ...this.state.locationData, postalCode: value }

                            if (isValid) {
                                let statel = postalCodeLookup(value)
                                newLocationData.stateCode = statel
                            }

                            this.setState({ locationData: newLocationData, postalCodeFormatError: !isValid }, () => this.isDirty())
                        }}
                        variant="standard"
                        label="Postal Code"
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        value={this.state.locationData.stateCode}
                        label="State Code"
                        disabled={true}
                        margin="normal"
                        variant="standard"
                        style={{ width: '100%' }}
                    ></TextField>
                </Grid>

                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    <Button onClick={() => { this.props.updateLocationData(this.state.locationData) }}
                        disabled={
                            this.props.updateLocationDataBusy
                            || !this.state.isDirty
                            || this.state.postalCodeFormatError
                            || this.state.locationData.postalCode === ""
                            || this.state.locationData.stateCode === ""
                            || this.state.locationData.street === ""
                            || this.state.locationData.streetNumber === ""
                            || this.state.locationData.suburb === ""
                        } variant="contained" color="primary">Save changes</Button>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    {this.props.updateLocationDataBusy &&
                        <CircularProgress size={30} />
                    }
                </Grid>
            </Grid>
        );
    }
}

export default LocationDetails;